import React, { useContext, useEffect, useState, useRef } from "react";
import ImageContainer from "../ImageContainer";
import axios from "axios";
import { successToaster, url } from "../../Data/Data";
import { useNavigate, useParams } from "react-router-dom";
import ImagesTable from "../ImagesTable";
import { Images_Template } from "../../Data/Data";
import ImagesFilters from "./ImagesFilters";
import Popup from "reactjs-popup";
import JSZip from "jszip";
import CryptoJS from "crypto-js";
import { saveAs } from "file-saver";
import TadobaContext from "../Context/TadobaContext";
import { makeRequest, makeRequest2 } from "../../api";
import { DatePicker } from "antd";
import moment from "moment";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-toastify";
import { warningToaster } from "../../Data/Data";
import ImageEdit from "./ImageEdit";
// import ImageCarouselPopup from "./ImageCarouselPop";
import FilterDetails from "../FilterDetails";

const { RangePicker } = DatePicker;
const TigerGroupImages = (props) => {
  const { species_id, groupName } = useParams();
  const navigate = useNavigate();
  const [species, setSpecies] = useState([]);
  const api = useContext(TadobaContext);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState(false);
  const [count, setCount] = useState(0);
  const [render, setRender] = useState(1);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [scroll, setScroll] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [grid, stGrid] = useState(true);
  const [listData, setListData] = useState([]);
  const [exportedImages, setExportedImages] = useState([]);
  const [speciesData, setSpeciesData] = useState([]);
  const [filterSpecies, setFilterSpecies] = useState([]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [dateRangeText, setDateRangeText] = useState("");
  const [startDownload, setStartDownload] = useState(api.startDownload);
  const [allCheck, setAllCheck] = useState(false);
  const [exportedIds, setExportedIds] = useState([]);
  const [tigerName, setTigerName] = useState(null);
  const [years, setYears] = useState([]);
  const [tigerId, setTigerId] = useState([]);
  const [downloadXl, setDownloadXl] = useState("0");
  const [selectedOption, setSelectedOption] = useState("");
  const [abortController, setAbortController] = useState(null);
  const [deletedImageList, setDeletedImageList] = useState([]);
  const prevStartDeleteRef = useRef(api.startDelete);
  const [filtersArray, setFiltersArray] = useState([]);
  const [isEditImgOpen, setIsEditImgOpen] = useState(false);
  const [imageEditId, setImageEditId] = useState("");
  const [customTimeRange, setCustomTimeRage] = useState({});

  const imgContainerRef = useRef();

  const resetRefs = () => {
    if (imgContainerRef.current) {
      imgContainerRef.current.resetStates();
    }
  };

  useEffect(() => {
    const tigerType =
      groupName === "Unclassified"
        ? "unidentified_tigers"
        : "individual_identified_tigers";
    getImages(tigerType);
    setTigerName(tigerType);
  }, [render, page]);

  useEffect(() => {
    const fetchSpeciesData = async () => {
      try {
        const response = await makeRequest("get", `api/v1/species/species/`);
        setSpeciesData(response.data.data);
        extractTigerId(response.data.data);
      } catch (error) {
        console.error("Error fetching species data:", error);
      }
    };

    fetchSpeciesData();
  }, []);

  const extractTigerId = (data) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].name.toLowerCase() === "tiger") {
        setSpecies([data[i].id]);
      }
    }
  };

  const handleCalendarClick = () => {
    setShowDatePicker(true);
  };

  const getImages = async (tigerType) => {
    if (filter === true) {
      filterApply();
      return;
    }
    setScroll(true);
    if (page <= currentPage) {
      setLoading(false);
      return;
    }
    let token = "";
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      const result = await makeRequest(
        "get",
        `api/v1/identification/${tigerType}/?page=${page}&size=20&tiger_name=${groupName}`
      );
      const tempData = result.data.data;
      if (tigerType === "individual_identified_tigers") {
        const id = result.data.data[0].specie_sub_type.id;
        setTigerId([id]);
      } else {
        setTigerId([]);
      }
      const newData = tempData.map((row, key) => {
        const obj = { ...row };
        obj.checked = false;
        return obj;
      });
      setCount(result.data.count);
      if (newData.length === 0) {
      } else {
        const formattedList = [];

        for (const cameraData of newData) {
          const name = cameraData?.id;
          const species = cameraData?.species?.name;
          const dateString = cameraData.captured_at;
          const dateObj = new Date(dateString);
          const options = {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: true,
            timeZone: "UTC",
          };

          const formattedDate = new Intl.DateTimeFormat(
            "en-US",
            options
          ).format(dateObj);
          let checked = false;
          if (allCheck) {
            checked = true;
          }
          const formattedData = {
            Name: name || "Name not avilable",
            Species: species || "Unclassified",
            "Station ID": cameraData.station.name.toString(),
            "Camera ID": cameraData.camera.name.toString(),
            Range: cameraData.range.name.toString(),
            "Date and Time": formattedDate,
            image: cameraData.image,
            checked: checked,
            id: cameraData.id,
          };
          formattedList.push(formattedData);
        }
        setListData((prevData) => [...prevData, ...formattedList]);
        setData((prevData) => [...prevData, ...newData]);
        setCurrentPage(currentPage + 1);
        setLoading(false);
        setScroll(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const downloadAllImages = async () => {
    const controller = new AbortController();
    setAbortController(controller);
    api.setStartDownload(true);
    api.setDisable(true);
    localStorage.setItem("disable", true);
    setStartDownload(true);
    const data = api.filterQuery;
    const geolocationRange = [];
    const geolocationRound = [];
    const geolocationBeat = [];
    const geolocationCompartment = [];
    const geolocationStation = [];
    const geolocationCamera = [];
    const size = 20;
    let tiger_types = [];
    if (groupName === "Unclassified") {
      tiger_types = ["Unclassified"];
    } else {
      tiger_types = tigerId;
    }
    for (const entry of Object.values(data)) {
      const [key, value] = entry.split("=");
      if (key === "range_name") {
        geolocationRange.push(value);
      } else if (key === "round_name") {
        geolocationRound.push(value);
      } else if (key === "beat_name") {
        geolocationBeat.push(value);
      } else if (key === "compartment_name") {
        geolocationCompartment.push(value);
      } else if (key === "station_name") {
        geolocationStation.push(value);
      } else if (key === "camera_name") {
        geolocationCamera.push(parseInt(value));
      }
    }
    const result_data = {
      geolocation_range: geolocationRange,
      geolocation_round: geolocationRound,
      geolocation_beat: geolocationBeat,
      geolocation_compartment: geolocationCompartment,
      geolocation_station: geolocationStation,
      geolocation_camera: geolocationCamera,
      species: species,
      tiger_types: tiger_types,
      years: years,
      start_date: customTimeRange?.start_date,
      end_date: customTimeRange?.end_date,
    };
    let token = "";
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      let data = {};
      if (allCheck) {
        data = {
          image_ids: [],
          specie_id: "",
          species_data_name: groupName,
          download_xl: downloadXl,
          camera_id: "",
          filters: result_data,
        };
      }
      if (exportedIds.length > 0) {
        data = {
          image_ids: exportedIds,
          specie_id: "",
          camera_id: "",
          download_xl: downloadXl,
          filters: result_data,
        };
      } else {
      }

      console.log(data);

      if ((allCheck || exportedIds.length > 0) && downloadXl === "0") {
        const displayCount = allCheck ? count : exportedIds.length;
        const finalCount = Math.min(displayCount, 5000);

        if (finalCount >= 5000) {
          toast.success("Download Limit - 5000 Images", warningToaster);
          console.log("Download Limit - 5000 Images");
          api.setStartDownload(false);
          setStartDownload(false);
          localStorage.setItem("disable", false);
          api.setDisable(false);
          return;
        }

        api.setDownloadingText(`Downloading ${finalCount} Images....`);
        localStorage.setItem("text", `Downloading ${finalCount} Images....`);
      }
      if (downloadXl === "1") {
        api.setDownloadingText(`Downloading Excel File....`);
        localStorage.setItem("text", `Downloading Excel File....`);
      }

      api.setDownloadQuery(data);
      setDownloadXl("0");
    } catch (error) {
      console.error("Failed to create download link:", error);
      api.setDownloadingText("");
      api.setStartDownload(false);
      setStartDownload(false);
      localStorage.setItem("disable", false);
      api.setDisable(false);
    }
  };

  useEffect(() => {
    if (exportedImages.length !== 0 || allCheck) {
      api.setDisable(false);
    } else {
      api.setDisable(true);
    }
  }, [exportedImages, allCheck]);

  function handleExportOption(event) {
    const option = event.target.value;

    switch (option) {
      case "excel":
        console.log("1");
        setDownloadXl("1");

        break;
      case "images":
        downloadAllImages();
        break;
      default:
        console.log("No action for this option");
    }
    setSelectedOption("");
  }
  useEffect(() => {
    if (downloadXl === "1") {
      downloadAllImages();
    }
  }, [downloadXl]);

  function decryptImageUrl(encryptedUrl, key) {
    key = CryptoJS.enc.Utf8.parse(key.slice(0, 32)); // Truncate or expand key to 32 bytes
    const encodedData = CryptoJS.enc.Base64.parse(encryptedUrl);
    const iv = CryptoJS.lib.WordArray.create(encodedData.words.slice(0, 4));
    const data = CryptoJS.lib.WordArray.create(encodedData.words.slice(4));

    const decryptedData = CryptoJS.AES.decrypt({ ciphertext: data }, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
    return decryptedText;
  }

  const downloadImages = async () => {
    const imageUrls = [...exportedImages];
    const zip = new JSZip();

    const headers = new Headers();
    headers.append("Access-Control-Allow-Origin", "*");
    const downloadPromises = imageUrls.map(async (imageUrl, index) => {
      const decryptUrl = await decryptImageUrl(
        imageUrl,
        localStorage.getItem("image_key")
      );
      const response = await fetch(decryptUrl, { headers });
      const imageData = await response.blob();
      zip.file(`image${index + 1}.jpg`, imageData);
      return Promise.resolve();
    });
    await Promise.all(downloadPromises);
    const zipBlob = await zip.generateAsync({ type: "blob" });
    saveAs(zipBlob, "images.zip");
  };

  const deleteImage = async (array, close) => {
    let array_data = array;
    setDeletedImageList(array_data);
    setListData((prevListData) =>
      prevListData.filter((item) => !array_data.includes(item.Name))
    );

    const data = api.filterQuery;
    const geolocationRange = [];
    const geolocationRound = [];
    const geolocationBeat = [];
    const geolocationCompartment = [];
    const geolocationStation = [];
    const geolocationCamera = [];
    const size = 20;
    let tiger_types = [];
    if (groupName === "Unclassified") {
      tiger_types = ["Unclassified"];
    } else {
      tiger_types = tigerId;
    }

    for (const entry of Object.values(data)) {
      const [key, value] = entry.split("=");
      if (key === "range_name") {
        geolocationRange.push(value);
      } else if (key === "round_name") {
        geolocationRound.push(value);
      } else if (key === "beat_name") {
        geolocationBeat.push(value);
      } else if (key === "compartment_name") {
        geolocationCompartment.push(value);
      } else if (key === "station_name") {
        geolocationStation.push(value);
      } else if (key === "camera_name") {
        geolocationCamera.push(parseInt(value));
      }
    }
    const result_data = {
      geolocation_range: geolocationRange,
      geolocation_round: geolocationRound,
      geolocation_beat: geolocationBeat,
      geolocation_compartment: geolocationCompartment,
      geolocation_station: geolocationStation,
      geolocation_camera: geolocationCamera,
      species: species,
      tiger_types: tiger_types,
      years: years,
      start_date: customTimeRange?.start_date,
      end_date: customTimeRange?.end_date,
    };
    let token = "";
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      let data = {};
      if (allCheck) {
        data = {
          image_ids: ["all"],
          filters: result_data,
        };
      }
      if (exportedIds.length > 0) {
        data = {
          image_ids: exportedIds,
          filters: result_data,
        };
      } else {
        data = {
          image_ids: array_data,
          filters: result_data,
        };
      }
      if (allCheck || exportedIds.length > 0) {
        let displayCount;

        if (allCheck) {
          displayCount = count;
        } else if (exportedIds.length > 0) {
          displayCount = exportedIds.length;
        } else if (array_data.length > 0) {
          displayCount = array_data.length;
        }
        const finalCount = Math.min(displayCount, 5000);
        if (finalCount >= 5000) {
          toast.success("Delete Limit - 5000 Images", warningToaster);
          console.log("Delete Limit - 5000 Images");
          api.setStartDelete(false);
          return;
        }
        api.setDownloadingText(`Deleting ${finalCount} Images....`);
        localStorage.setItem("text", `Deleting ${finalCount} Images....`);
      }
      api.setStartDelete(true);
      api.setDeleteQuery(data);
      api.setDisable(true);

      close();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (prevStartDeleteRef.current === true && api.startDelete === false) {
      // setCurrentPage(0);
      setListData((prevListData) =>
        prevListData.filter((item) => !deletedImageList.includes(item.id))
      );
      setData((prevData) =>
        prevData.filter((item) => !deletedImageList.includes(item.id))
      );
      // setLoading(true);
      // setPage(1);
      // setRender(render + 1);
      api.setDeleteQuery([]);
      setAllCheck(false);
      setExportedIds([]);
    }
    prevStartDeleteRef.current = api.startDelete;
  }, [api.startDelete]);

  const filterApply = async (close) => {
    setFilter(true);
    const data = api.filterQuery;
    const geolocationRange = [];
    const geolocationRound = [];
    const geolocationBeat = [];
    const geolocationCompartment = [];
    const geolocationStation = [];
    const geolocationCamera = [];
    const size = 20;
    let tiger_types = [];
    if (groupName === "Unclassified") {
      tiger_types = ["Unclassified"];
    } else {
      tiger_types = tigerId;
    }
    for (const entry of Object.values(data)) {
      const [key, value] = entry.split("=");
      if (key === "range_name") {
        geolocationRange.push(value);
      } else if (key === "round_name") {
        geolocationRound.push(value);
      } else if (key === "beat_name") {
        geolocationBeat.push(value);
      } else if (key === "compartment_name") {
        geolocationCompartment.push(value);
      } else if (key === "station_name") {
        geolocationStation.push(value);
      } else if (key === "camera_name") {
        geolocationCamera.push(parseInt(value));
      }
    }
    const result_data = {
      geolocation_range: geolocationRange,
      geolocation_round: geolocationRound,
      geolocation_beat: geolocationBeat,
      geolocation_compartment: geolocationCompartment,
      geolocation_station: geolocationStation,
      geolocation_camera: geolocationCamera,
      species: species,
      tiger_types: tiger_types,
      page: page,
      size: size,
      years: years,
      start_date: customTimeRange?.start_date,
      end_date: customTimeRange?.end_date,
    };

    setScroll(true);
    if (page <= currentPage) {
      setLoading(false);
      return;
    }
    let token = "";
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      const result = await makeRequest(
        "post",
        `api/v1/classification/image_filter/`,
        result_data
      );
      const tempData = result.data.data;
      const newData = tempData.map((row, key) => {
        const obj = { ...row };
        obj.checked = false;
        return obj;
      });
      setCount(result.data.count);
      const speciesIds = result_data.species;
      const matchedSpeciesNames = speciesIds
        .map((speciesId) => {
          const matchedSpecies = speciesData.find(
            (speciesEntry) => speciesEntry.id === speciesId
          );
          return matchedSpecies ? matchedSpecies.name : null;
        })
        .filter((name) => name !== null);
      setFilterSpecies(matchedSpeciesNames);

      if (newData.length === 0) {
      } else {
        const formattedList = [];

        for (const cameraData of newData) {
          const name = cameraData?.id;
          const species = cameraData?.species?.name;
          const dateString = cameraData.captured_at;
          const dateObj = new Date(dateString);
          const options = {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: true,
            timeZone: "UTC",
          };

          const formattedDate = new Intl.DateTimeFormat(
            "en-US",
            options
          ).format(dateObj);
          let checked = false;
          if (allCheck) {
            checked = true;
          }
          const formattedData = {
            Name: name,
            Species: species || "Unclassified",
            "Station ID": cameraData.station.name.toString(),
            "Camera ID": cameraData.camera.name.toString(),
            Range: cameraData.range.name.toString(),
            "Date and Time": formattedDate,
            image: cameraData.image,
            checked: checked,
            id: cameraData.id,
          };
          formattedList.push(formattedData);
        }
        setListData((prevData) => [...prevData, ...formattedList]);
        setData((prevData) => [...prevData, ...newData]);
        setCurrentPage(currentPage + 1);
        setLoading(false);
        setScroll(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const customDateChangeHandler = (dates, dateStrings) => {
    setSelectedDateRange(dates);
    if (dateStrings[0] && dateStrings[1]) {
      setDateRangeText(
        `${moment(dateStrings[0]).format("D MMMM YYYY")} - ${moment(
          dateStrings[1]
        ).format("D MMMM YYYY")}`
      );
    } else {
      setDateRangeText("");
    }
  };

  const editImage = (value) => {
    // props.setEdit(true);
    // navigate(`/images/${value.id}`);
    setImageEditId(value.id);
    setIsEditImgOpen(true);
  };
  const clearFilter = () => {
    setFilterSpecies([]);
  };

  const cancelDownload = () => {
    if (abortController) {
      console.log("abort");
      abortController.abort(); // Abort the ongoing request
      setAbortController(null); // Reset the controller in the state
    }
    api.setDownloadingText("");
    api.setStartDownload(false);
    setStartDownload(false);
    localStorage.setItem("disable", false);
    api.setDisable(false);
  };

  const closeEditImgPopup = () => setIsEditImgOpen(false);

  const revertTigerIdentification = async (name) => {
    let token = "";
    setLoading(true);

    try {
      if (localStorage.token) {
        token = localStorage.token;
      }

      const result = await makeRequest(
        "put",
        "api/v1/identification/revert_tiger_identification/",
        { id: name },
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${token}`
          },
        }
      );
        const filteredItems = listData.filter(item => item.id !== name);
        setListData(filteredItems)
        toast.success(`Successfully Unidentified Image`, {
          ...successToaster,
          autoClose: 2000, 
        });
      
    } catch (error) {
      toast.success(`Unidentification Unsuccessful`, {
        ...warningToaster,
        autoClose: 2000, 
      })
      console.error("Error reverting tiger identification:", error);         
    }
  };

  return (
    <div className="Setting_User">
      <div className="Setting_User_Header">
        <div className="Images_Filter_Container">
          <span>
            {groupName === "Unclassified" ? "Unidentified" : groupName}
          </span>
              <span className="Filter_Species_Display">
                <FilterDetails filtersArray={filtersArray} />
              </span>
              <span className="Filter_Species_Display">
                {years.length > 0 && <span>(</span>}
                {years.slice(0, 3).map((year, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && <span>, </span>}
                    <span>{year}</span>
                  </React.Fragment>
                ))}
                {years.length > 3 && <span>, ...</span>}
                {years.length > 0 && <span>)</span>}
                {customTimeRange?.start_date && customTimeRange?.end_date && (
                  <span>
                    {customTimeRange?.start_date} - {customTimeRange?.end_date}
                  </span>
                )}
              </span>
        </div>

        <div className="Setting_User_Attribute">
          {/* {exportedImages.length > 1 && (
            <EditMultipleImages
              getImages={getImages}
              exportedIds={exportedIds}
              onReset={resetRefs}
              setExportedImages={setExportedImages}
              setExportedIds={setExportedIds}
              allImages={false}
              groupTiger={true}
            />
          )} */}
          <Popup
            trigger={
              <div className="role_filter">
                <img src={require("../../Assets/Icons/filter.png")} alt="" />
                {filterSpecies.length > 0 && (
                  <span className="filter_count"></span>
                )}
              </div>
            }
            modal
            nested
          >
            {(close) => (
              <ImagesFilters
                species={species}
                setFilter={setFilter}
                setRender={setRender}
                render={render}
                close={close}
                setLoading={setLoading}
                setCurrentPage={setCurrentPage}
                setData={setData}
                setListData={setListData}
                setPage={setPage}
                filterApply={filterApply}
                setSpecies={setSpecies}
                clearFilter={clearFilter}
                setYears={setYears}
                type={"tiger images"}
                setFiltersArray={setFiltersArray}
                customRange={customTimeRange}
                setCustomRange={setCustomTimeRage}
              />
            )}
          </Popup>
          {/* <div className="role_Calander" onClick={handleCalendarClick}>
            <img
              src={require("../../Assets/Icons/Calander.png")}
              style={{ display: showDatePicker ? "none" : "block" }}
              alt=""
            />
            {dateRangeText && (
              <span
                style={{
                  display: showDatePicker ? "none" : "block",
                  fontSize: "0.85rem",
                  color: "#594F42",
                  marginLeft: "12px",
                }}
              >
                {dateRangeText}
              </span>
            )}
            {showDatePicker && (
              <RangePicker
                value={selectedDateRange}
                format="YYYY-MM-DD"
                onChange={customDateChangeHandler}
                bordered={false}
                size="small"
                onOpenChange={(open) => {
                  setCurrentPage(0);
                  setData([]);
                  setListData([]);
                  setFilter(true);
                  setLoading(true);
                  setPage(1);
                  setRender(render + 1);
                  setShowDatePicker(open);
                  clearFilter();
                }}
              />
            )}
          </div> */}
          {/* {exportedImages.length !== 0 || allCheck ? (
            <button
              className={`role_filter ${api.disable ? "disabled" : ""}`}
              onClick={downloadAllImages}
              disabled={api.disable}
            >
              Export
            </button>
          ) : (
            ""
          )} */}
          <div className={`role_filter ${api.disable ? "disabled" : ""}`}>
            <select
              onChange={handleExportOption}
              disabled={api.disable}
              // defaultValue=""
              value={selectedOption}
            >
              <option value="" disabled hidden>
                Export
              </option>
              <option value="excel">As Excel</option>
              <option value="images">As Images</option>
            </select>
          </div>
        </div>
      </div>
      {grid ? (
        <div style={{ position: "relative" }}>
          {/* {startDownload && (
            <div
              className="upload"
              style={{
                position: "absolute",
                bottom: "80px", // Adjust as needed
                right: "50px", // Adjust as needed
                width: "20%",
                height: "20%",
                border: "2px solid orange", // Add border style
                zIndex: 1,
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                onClick={() => cancelDownload()} // Add a function to handle the close action
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                <img src={require("../../Assets/Icons/Close.png")} alt="" />
              </button>
              <ClipLoader
                color={"orange"}
                loading={true}
                size={50}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
              <div style={{ marginTop: "10px" }}>
                {(allCheck || exportedIds.length > 0) && (
                  <p>{localStorage.text}</p>
                )}
              </div>
            </div>
          )} */}
          <ImageContainer
            exportedImages={exportedImages}
            scroll={scroll}
            setExportedImages={setExportedImages}
            currentPage={currentPage}
            grid={grid}
            setGrid={stGrid}
            setCurrentPage={setCurrentPage}
            page={page}
            setPage={setPage}
            count={count}
            setData={setListData}
            data={listData}
            getImages={getImages}
            deleteImage={deleteImage}
            editImage={editImage}
            type={"Classified"}
            loading={loading}
            setAllCheck={setAllCheck}
            setExportedIds={setExportedIds}
            ref={imgContainerRef}
            contentType={'group_tiger'}
            groupName={groupName}
            revertTigerIdentification={revertTigerIdentification}
            hoverRevert={true}
          />
        </div>
      ) : (
        <ImagesTable
          exportedImages={exportedImages}
          scroll={scroll}
          setExportedImages={setExportedImages}
          currentPage={currentPage}
          grid={grid}
          setGrid={stGrid}
          delete={true}
          setCurrentPage={setCurrentPage}
          page={page}
          setPage={setPage}
          setData={setListData}
          count={count}
          data={listData}
          getImages={getImages}
          deleteImage={deleteImage}
          editImage={editImage}
          type={"Classified"}
          template={Images_Template}
          loading={loading}
          setAllCheck={setAllCheck}
          setExportedIds={setExportedIds}
        />
      )}
      <Popup
        open={isEditImgOpen}
        onClose={closeEditImgPopup}
        modal
        closeOnDocumentClick={false}
      >
        <ImageEdit
          closeEditImgPopup={closeEditImgPopup}
          id={imageEditId}
          revertTiger={true}
          listData={listData}
          setListData={setListData}
          allImages={false}
        />
      </Popup>
    </div>
  );
};

export default TigerGroupImages;
